import { Answer } from '@components/answer/Answer'
import { useFormEditor } from '@contexts/FormContext'
import { FormItem as FormItemModel, FormItemTypes } from '@models/Form'
import { requiredRule } from '@utils/rules'
import { Form as ANTDForm, Card, Flex, Space, Typography } from 'antd'
import { useFormItemControl } from './useFormItemControl'

const { Text, Title } = Typography

interface Props {
  item: FormItemModel
}

export const FormItem = ({ item }: Props) => {
  const { isManager, isFulfilled, isEmployee } = useFormEditor()
  const control = useFormItemControl({ item, isFulfilled })

  // Exceptions for non-fillable form items
  if (item.type.id === FormItemTypes.Title) {
    return (
      <Space size={0} key={item.id} vertical>
        <Title level={5}>{item.question}</Title>
        <Text italic type="secondary">
          {item.description}
        </Text>
      </Space>
    )
  } else if (item.type.id === FormItemTypes.Spacer) {
    return <div style={{ height: 50 }}></div>
  }

  return (
    <Card styles={{ body: { paddingBottom: 0 } }}>
      <Space vertical className="w-full" size={20}>
        <Space size={0} vertical>
          <Space size={3}>
            {item.required && <Text style={{ color: 'red' }}>*</Text>}
            <Text>{item.question}</Text>
          </Space>
          <Text italic type="secondary">
            {item.description}
          </Text>
        </Space>
        {isManager && (
          <Flex vertical>
            <Answer.EmployeeReadOnly />
            <Answer.AssociatedAnswersPreview />
          </Flex>
        )}
        <Space size={5} vertical className="w-full">
          {(!isManager || item.isAnswerableByManager) && (
            <>
              <Text>
                <b>Votre réponse :</b>
              </Text>
              <ANTDForm.Item
                key={item.id}
                name={[item.id, control.name]}
                rules={item.required ? [requiredRule()] : []}
              >
                {control.content()}
              </ANTDForm.Item>
              {isEmployee && (
                <Answer.AssociatedAnswersPreview
                  spaceStyle={{ marginBottom: 32 }}
                />
              )}
            </>
          )}

          {isManager && <Answer.ManagerComment />}

          {isEmployee && isFulfilled && (
            <Space vertical className="w-full">
              <Answer.ManagerAnswerReadOnly />
              <Answer.ManagerCommentReadOnly />
            </Space>
          )}
        </Space>
      </Space>
    </Card>
  )
}

export type FormItemType = { FormItem: typeof FormItem }
